import React from 'react';
import { Box, Typography } from '@mui/material';
import { exchangeSpecificStringifiedNumber } from '../../../services/exchanges';
import { formatPriceWithPrecision } from '../../../utils/utilfunction';

const PriceInfo = ({ instrument }) => {
  // console.log(instrument);
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-end",
        minWidth: 'fit-content',
        ml: 2
      }}
    >
      <Box
        component="span"
        sx={{
          fontWeight: "medium",
          fontSize: "0.875rem",
          lineHeight: 1.2,
          display: "flex",
          alignItems: "center",
        }}
      >
        {instrument.ltp
          ? ((instrument.exchange === 'CDS' || instrument.exchange === 'DCSX') && instrument.price_precision !== undefined)
              ? formatPriceWithPrecision(instrument.ltp, instrument.price_precision, {
                  showCurrency: false,
                  showCommas: false,
                  removeTrailingZeros: false
                })
              : exchangeSpecificStringifiedNumber(instrument.exchange, instrument.ltp)
          : "0.00"}
      </Box>
      <Typography
        sx={{
          color:
            instrument.absoluteChange > 0
              ? "success.main"
              : instrument.absoluteChange < 0
              ? "error.main"
              : "text.secondary",
          fontWeight: "medium",
          fontSize: "0.75rem",
          lineHeight: 1.2,
        }}
        variant="caption"
      >
        {((instrument.exchange === 'CDS' || instrument.exchange === 'DCSX') && instrument.price_precision !== undefined)
          ? formatPriceWithPrecision(instrument.absoluteChange, instrument.price_precision, {
              showCurrency: false,
              showCommas: false,
              removeTrailingZeros: false
            })
          : exchangeSpecificStringifiedNumber(
              instrument.exchange,
              instrument.absoluteChange
            )}
        {instrument.exchange !== 'CDS' && instrument.exchange !== 'DCSX' && (
          <>
            {" "}
            <Typography
              sx={{
                color:
                  instrument.percentChange > 0
                    ? "success.main"
                    : instrument.percentChange < 0
                    ? "error.main"
                    : "text.secondary",
                fontWeight: "medium",
                fontSize: "0.75rem",
                lineHeight: 1.2,
              }}
              variant="caption"
              component="span"
            >
              ({exchangeSpecificStringifiedNumber(
                    instrument.exchange,
                    instrument.percentChange
                  )}
              %)
            </Typography>
          </>
        )}
      </Typography>
    </Box>
  );
};

export default PriceInfo; 
